import React from 'react';

type InlineStatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'error';

interface InlineStatusProps {
  tone?: InlineStatusTone;
  title?: React.ReactNode;
  message: React.ReactNode;
  meta?: React.ReactNode;
  action?: React.ReactNode;
  compact?: boolean;
  className?: string;
}

const toneIcons: Record<InlineStatusTone, React.ReactNode> = {
  neutral: <span className="inline-status__dot" aria-hidden="true" />,
  info: <span className="inline-status__dot" aria-hidden="true" />,
  success: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="m5 10 3 3 7-7" />
    </svg>
  ),
  warning: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6.5v4m0 3h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.574 3.217a1.75 1.75 0 0 1 2.852 0l6.098 8.653A1.75 1.75 0 0 1 16.098 14.5H3.902a1.75 1.75 0 0 1-1.426-2.63l6.098-8.653Z" />
    </svg>
  ),
  error: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6.5v4m0 3h.01" />
      <circle cx="10" cy="10" r="7" />
    </svg>
  ),
};

export default function InlineStatus({
  tone = 'neutral',
  title,
  message,
  meta,
  action,
  compact = false,
  className = '',
}: InlineStatusProps) {
  return (
    <div className={`inline-status inline-status--${tone} ${compact ? 'inline-status--compact' : ''} ${className}`.trim()}>
      <div className="inline-status__icon">{toneIcons[tone]}</div>
      <div className="inline-status__body">
        {title ? <div className="inline-status__title">{title}</div> : null}
        <div className="inline-status__message">{message}</div>
        {meta ? <div className="inline-status__meta">{meta}</div> : null}
      </div>
      {action ? <div className="inline-status__action">{action}</div> : null}
    </div>
  );
}
